if (!customElements.get('gift-card-recipient')) {
  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.recipientEmail = this.querySelector('[name="properties[giftee-recipientEmail]"]');
      this.recipientEmailLabel = this.querySelector(`label[for="${this.recipientEmail.id}"]`);
      this.recipientConfirmationEmail = this.querySelector('[name="properties[giftee-confirmRecipientEmail]"]');
      this.recipientConfirmationEmailLabel = this.querySelector(`label[for="${this.recipientConfirmationEmail.id}"]`);
      this.recipientName = this.querySelector('[name="properties[giftee-recipientName]"]');
      this.recipientMessage = this.querySelector('[name="properties[giftee-personalMessage]"]');
      this.recipientSendOn = this.querySelector('[name="properties[Send on]"]');
      this.recipientOffsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');
      this.senderName = this.querySelector('[name="properties[giftee-senderName]"]');
      this.senderEmail = this.querySelector('[name="properties[giftee-senderEmail]"]');
      this.sendDateTime = this.querySelector('[name="properties[giftee-sendDateTime]"]');
      this.sendOption = this.querySelector('[name="properties[giftee-sendOption]"]');
      this.senderEmailLabel = this.querySelector(`label[for="${this.senderEmail.id}"]`);

      // When JS is enabled, the recipient email field is required.
      // Input labels are changed to reflect this.
      [this.recipientEmailLabel, this.recipientConfirmationEmailLabel, this.senderEmailLabel].forEach(label => {
        if (label && label.dataset.jsLabel) {
          label.innerText = label.dataset.jsLabel;
        }
      });

      // Set the timezone offset property input and enable it
      if (this.recipientOffsetProperty) {
        this.recipientOffsetProperty.value = new Date().getTimezoneOffset().toString();
        this.recipientOffsetProperty.removeAttribute('disabled');
      }

      this.recipientCheckbox = this.querySelector('.gift-card-recipient__checkbox');
      this.recipientCheckbox.addEventListener('change', () => this.synchronizeProperties());

      this.recipientEmail.addEventListener('input', () => this.validateEmailMatch());
      this.recipientConfirmationEmail.addEventListener('input', () => this.validateEmailMatch());

      this.synchronizeProperties();
    }

    validateEmailMatch() {
      if (this.recipientConfirmationEmail.value && this.recipientEmail.value !== this.recipientConfirmationEmail.value) {
        this.recipientConfirmationEmail.setCustomValidity('Emails do not match');
      } else {
        this.recipientConfirmationEmail.setCustomValidity('');
      }
    }

    synchronizeProperties() {
      if (this.recipientCheckbox.checked) {
        this.recipientName.setAttribute('required', '');
        this.recipientEmail.setAttribute('required', '');
        this.recipientConfirmationEmail.setAttribute('required', '');
        this.senderName.setAttribute('required', '');
        this.senderEmail.setAttribute('required', '');
        this.recipientName.removeAttribute('disabled');
        this.recipientEmail.removeAttribute('disabled');
        this.recipientConfirmationEmail.removeAttribute('disabled');
        this.recipientMessage.removeAttribute('disabled');
        this.senderName.removeAttribute('disabled');
        this.senderEmail.removeAttribute('disabled');
        this.sendDateTime.removeAttribute('disabled');
        this.sendOption.removeAttribute('disabled');
        if (this.recipientSendOn) {
          this.recipientSendOn.removeAttribute('disabled');
        }
        if (this.recipientOffsetProperty) {
          this.recipientOffsetProperty.removeAttribute('disabled');
        }
      } else {
        this.recipientConfirmationEmail.setCustomValidity('');
        this.recipientName.removeAttribute('required');
        this.recipientEmail.removeAttribute('required');
        this.recipientConfirmationEmail.removeAttribute('required');
        this.senderName.removeAttribute('required');
        this.senderEmail.removeAttribute('required');
        this.recipientName.setAttribute('disabled', '');
        this.recipientEmail.setAttribute('disabled', '');
        this.recipientConfirmationEmail.setAttribute('disabled', '');
        this.recipientMessage.setAttribute('disabled', '');
        this.senderName.setAttribute('disabled', '');
        this.senderEmail.setAttribute('disabled', '');
        this.sendDateTime.setAttribute('disabled', '');
        this.sendOption.setAttribute('disabled', '');
        if (this.recipientSendOn) {
          this.recipientSendOn.setAttribute('disabled', '');
        }
        if (this.recipientOffsetProperty) {
          this.recipientOffsetProperty.setAttribute('disabled', '');
        }
      }
    }
  }

  customElements.define('gift-card-recipient', GiftCardRecipient);
}
